import { useState, useEffect } from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { getCategory, updateCategory } from '../../services/Configs/ItemCategoriesService'

function EditItemCategoryModal({ categoryId, show, handleClose, handleReload }) {
  const [formData, setFormData] = useState({
    id: 0,
    categoryName: '',
    isActive: false
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleUpdateCategory = () => {
    let pendingInputs = [];

    if (!formData.categoryName) {
      pendingInputs.push("Categoría")
    }

    if (pendingInputs.length == 0) {
      updateCategory(formData.id, formData.categoryName, formData.isActive).then(locationResult => {
        toast.success('Categoría actualizada correctamente');
        handleClose();
        handleReload();
      });
    }
    else {
      toast.warning(`Lo sentimos, debes completar los siguientes campos: ${pendingInputs.join(', ')}`)
    }
  }

  useEffect(() => {
    if (show) {
      getCategory(categoryId).then(obj => {
        setFormData({
          id: obj.id,
          categoryName: obj.name,
          isActive: obj.isActive
        });
      })
    }
  }, [show]);

  return (
    <Modal size="sm" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Actualizar  categoría</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xl={12} className=' p-2'  >
            <Form.Label>Nombre:</Form.Label>
            <Form.Group controlId="">
              <Form.Control
                type="text"
                name="categoryName"
                placeholder='Nombre de la categoría'
                value={formData.categoryName}
                onChange={handleInputChange}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xl={12}>
            <Form.Group className='mt-3' controlId="formWorkFromHome">
              <Form.Label>Estado:</Form.Label>
              <Form.Check
                type="radio"
                label="Activa"
                name="isActive"
                value="true"
                checked={formData.isActive === true}
                onChange={() => setFormData({ ...formData, isActive: true })}
              />
              <Form.Check
                type="radio"
                label="Inactiva"
                name="isActive"
                value="false"
                checked={formData.isActive === false}
                onChange={() => setFormData({ ...formData, isActive: false })}
              />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleUpdateCategory}>
          Actualizar categoría
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditItemCategoryModal;